<template>
    <div class="goods-item" @click="gotoGoods(row.TransactionID,row.ItemDes.dwBaseID)">
       <div class="goods_pic">
            <div class="box">
                <img class="goods_icon" :src="row.icon_url" alt="">
            </div>
       </div>
       <div class="goods_info">
            <div class="name_num">
                <div class="name" v-if="row.ItemName.length > 7">
                    <p>{{ row.ItemName.slice(0,7) }}</p>
                    <p class="line2">{{ row.ItemName.slice(7,row.ItemName.length) }}</p>
                </div>
                <div class="name" v-else>
                    <p>{{ row.ItemName }}</p>
                </div>
                <div class="num">
                    <span class="prefix">数量：</span>
                    <span>{{ row.ItemDes.dwCount }}</span>
                </div>
            </div>
            <!-- <div class="price">
                <span class="prefix">参考价格：</span>
                <span class="yen">&yen;{{ row.min_price }}~{{ row.max_price }}</span>
            </div> -->
       </div>
    </div>
</template>

<script>
export default {
    name: 'goods-item',
    props: {
        row: [Array, Object],
    },
    filters: {

    },
    data() {
        return {
            
        }
    },
    methods: {
        gotoGoods(id,prop_id) {
            this.$router.push({
                name: 'sell.goods',
                query: {
                    transaction_id:id,
                    prop_id
                }
            })
        }
    },
}
</script>

<style lang="less" scoped>
.goods-item {
    width: 11.8rem;
    background-color: #fff;
    margin-bottom: .8rem;
    border-radius: .6rem;
    padding-bottom: 0.5rem;
    overflow: hidden;
    cursor: pointer;
    &:active {
        opacity: 0.9;
    }
    &:nth-child(3n+2) {
        margin-right: 0.5rem;
        margin-left: 0.5rem;
    }
    .goods_pic {
        height: 8.6rem;
        width: 100%;
        background: url(../assets/bx/goods_bg.png) no-repeat 0 0 / 100% 100%;
        position: relative;
        .box {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            width: 4rem;
            height: 4rem;
            background: url(../assets/bx/goods_kuang.png) no-repeat 0 0 / 100% 100%;
            .goods_icon {
                height: 100%;
            }
        }
    }
    .goods_info {
        padding: .3rem .5rem 0;
        .name_num {
            height: 4.8rem;
            .name {
               font-size: 1.3rem;
               width: 100%;
               word-break: break-all;
               line-height: 1.2;
            }
            .num {
                color: #aaa;
                font-size: 1.2rem;
                transform: scale(0.95);
                transform-origin: 0 0;
                .suffix {
                    color: var(--enough);
                }
            }
        }
        .price {
            word-break: break-all;
            font-size: 1.2rem;
            .prefix,
            .zw {
                color: #aaa;
                display: block;
            }
            .yen {
                color: var(--red);
                font-weight: 700;
            }
        }
    }
}
</style>